import { Alert } from "@material-ui/lab";
import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { AppContext } from "../../../../App";
import { HTTP_STATUSES } from "../../../../utils/consts";
import { fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import Notification from "../../../elements/notification/Notification";
import { NavLink, useHistory } from "react-router-dom";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import AddService from "../../client/AddService";
import { useTranslation } from "react-i18next";

import { StyledServiceDetailsWrapper } from "../../styledServiceDetails";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledDocumentText, StyledDocumentTitle, StyledDocumentWrapper } from "../../../styles/styledTextDocument";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../../styles/styledTable";

const ServiceDetailsContainer = ({ match }) => {
  const { t } = useTranslation("servicePage");
  const [userServiceDetails, setUserServiceDetails] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const fetchUserService = () => {
    setLoading( true);

    const filterUrl = fetchFilterData({
      "service.id": match.params.id
    });

    axios.get("/api/user-services/" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        const userServices = response.data['hydra:member'];

        if (userServices.length <= 0) {
          return;
        }

        setUserServiceDetails(userServices.shift());
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    }).finally(()=>setLoading(false));
  };

  useEffect(() => {
    fetchUserService();
  }, []);

  if (loading) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  if (!userServiceDetails) {
    return <Alert severity="warning">{t("list.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{userServiceDetails.service.title} • eXsoft.io</title>
        </Helmet>
        <StyledServiceDetailsWrapper>
          <div className="services-details-head">
            <GoToBackButton handler={() => {history.goBack();}} />
            <AddService serviceID={userServiceDetails.service.id} />
          </div>
          <StyledDocumentWrapper>
            <StyledDocumentTitle
              as="h2"
              size="18"
            >
              {userServiceDetails.service.title}
            </StyledDocumentTitle>
            {/*<StyledDocumentText size="16">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, autem culpa, cum deleniti id modi
              obcaecati officia quis, ratione repellendus repudiandae tempora ullam vitae? Consectetur eius molestiae
              nisi
              quos velit.
            </StyledDocumentText>

            <StyledDocumentText size="16">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, autem culpa, cum deleniti id modi
              obcaecati officia quis, ratione repellendus repudiandae tempora ullam vitae? Consectetur eius molestiae
              nisi
              quos velit.
            </StyledDocumentText>*/}
            <StyledTable
              size="16"
              className="access-level-table"
            >
              <StyledTableHead
                col="2"
                className="access-level-table__head"
              >
                <StyledCol>{t("details.key")}:</StyledCol>
                <StyledCol>{t("details.value")}:</StyledCol>
              </StyledTableHead>
              <StyledTableBody className="access-level-table__body">
                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    ID
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {userServiceDetails.service.id}
                  </StyledCol>
                </StyledTableRow>

                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Name
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {userServiceDetails.service.name}
                  </StyledCol>
                </StyledTableRow>

                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Title
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {userServiceDetails.service.title}
                  </StyledCol>
                </StyledTableRow>

                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Tag
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {userServiceDetails.service.tag}
                  </StyledCol>
                </StyledTableRow>
              </StyledTableBody>
            </StyledTable>
          </StyledDocumentWrapper>
        </StyledServiceDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ServiceDetailsContainer;